// Trạng thái tồn theo lô (bucket) — bám theo status của IMEI nhưng dạng bucket số lượng.
// code khớp BATCH_STOCK_TYPE của backend (search-product-batch-stock.dto.js): lọc bucket > 0.
export const BATCH_STOCK_STATUS_OPTIONS = [
  { code: 'inStock', name: 'Còn bán được', checked: false },
  { code: 'transfer', name: 'Đang chuyển kho', checked: false },
  { code: 'warranty', name: 'Đang bảo hành', checked: false },
  { code: 'holding', name: 'Đang giữ hàng', checked: false },
];

export const PRODUCT_BATCH_TABLE_HEADERS = [
  // {
  //   key: 'stt',
  //   label: 'STT',
  //   sortable: false,
  //   thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  // },
  {
    key: 'batchCode',
    label: 'Mã lô',
    sortable: false,
    tdClass: 'nameCateClass',
    thClass: 'nameCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'productName',
    label: 'Tên sản phẩm',
    sortable: false,
    tdClass: 'nameCateClass',
    thClass: 'nameCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'storeName',
    label: 'Cửa hàng',
    sortable: false,
    tdClass: 'codeCateClass',
    thClass: 'codeCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'quantity',
    label: 'Tổng tồn',
    sortable: false,
    tdClass: 'codeCateClass',
    thClass: 'codeCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'importDate',
    label: 'Ngày nhập',
    sortable: false,
    tdClass: 'codeCateClass',
    thClass: 'codeCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'updatedAt',
    label: 'Cập nhật lần cuối',
    sortable: false,
    tdClass: 'codeCateClass',
    thClass: 'codeCateClass',
    thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
  },
  {
    key: 'actions',
    label: '',
    thStyle: { textAlign: 'center' },
  },
];
